(function () {
    'use strict';

    angular
        .module('EventListApp')
        .service('SharedData', shareddata);

    shareddata.$inject = ['$cookie'];

    function shareddata($cookie) {
        var key = '', evId = 0, webId = '', lang = 0, c = "ea_ws";

        this.GetEventID = function () {
            return evId;
        }

        this.GetKey = function () {
            return key;
        }

        this.GetWebID = function () {
            return webId;
        }

        this.SetEventID = function (id) {
            evId = id;
        }

        this.GetLang = function () {
            return lang;
        }

        this.SetLang = function (v) {
            lang = v;
        }

        this.Init = function () {
            $cookie.Get("ea_ws");
            evId = $cookie.GetValue('pid') || 0;
            lang = $cookie.GetValue('lng') || 0;
            webId = $cookie.GetValue('wid') || '';
            key = $cookie.GetValue('pc') || '';
        }

    }
})();